"use client";

import React, { useState } from "react";
import { Button } from "./ui/button";
import { formatCstDisplayDateTime } from "../utils/cstDate";
import { positionSupportsOweToToast } from "../utils/employeeRoleUtils";

export const PositionTipDeleteModal = ({
  isOpen,
  onClose,
  record,
  onDelete,
  positionName = "tip"
}) => {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    if (!record) return;

    setDeleting(true);
    try {
      await onDelete(record.id);
      onClose();
    } finally {
      setDeleting(false);
    }
  };

  if (!isOpen || !record) return null;

  const amountVal = parseFloat(
    record.tip_out_cash ?? record.amountcash ?? record.amount ?? record.tipsReceived ?? 0
  ) || 0;
  const taxVal = parseFloat(
    record.tax ?? record.commission ?? record.addedTokes ?? 0
  ) || 0;
  const showOweToToast = positionSupportsOweToToast(positionName);
  const oweVal = parseFloat(record.owe_to_toast || record.owetotoast || 0) || 0;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Confirm Deletion</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl"
          >
            &times;
          </button>
        </div>

        <p className="mb-4 text-gray-700">
          Are you sure you want to delete this {positionName.toLowerCase()} tip
          record?
        </p>

        <div className="bg-gray-100 p-4 rounded-md mb-6 space-y-1.5 text-sm">
          <p>
            <span className="font-medium text-gray-700">Date:</span>{" "}
            {formatCstDisplayDateTime(record.date)}
          </p>
          <p>
            <span className="font-medium text-gray-700">Employee:</span>{" "}
            {record.employee || record.empname || "-"}
          </p>
          <p>
            <span className="font-medium text-gray-700">Amount:</span> $
            {amountVal.toFixed(2)}
          </p>
          <p>
            <span className="font-medium text-gray-700">Commission:</span> $
            {taxVal.toFixed(2)}
          </p>
          {showOweToToast && parseFloat(oweVal) > 0 && (
            <p>
              <span className="font-medium text-gray-700">Owe To Toast:</span> $
              {parseFloat(oweVal).toFixed(2)}
            </p>
          )}
        </div>

        <div className="flex justify-center space-x-4">
          <Button variant="outline" onClick={onClose} disabled={deleting}>
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            className="bg-red-500 hover:bg-red-600 text-white font-medium"
            disabled={deleting}
          >
            {deleting ? "Deleting..." : "Delete"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PositionTipDeleteModal;
